import { createContext } from 'react';

export type AccountingSystemCtx = {
  showError: boolean;
  errorMessage: string;
  showSyncStarted: boolean;
};

const AccountingSystemContext = createContext<AccountingSystemCtx>({
  showError: false,
  showSyncStarted: false,
  errorMessage: '',
});

export default AccountingSystemContext;
